module.exports = __webpack_public_path__ + "static/media/galerija_2016 (4).43651dcb.jpg";